module.exports = __webpack_public_path__ + "static/media/meditate2.29414e3f.jpg";